module.exports = __webpack_public_path__ + "static/media/ondrej-clo.df1a874b.png";